import { Box, ButtonBase, Grid, Typography } from '@material-ui/core';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import { CheckCircle } from '@material-ui/icons';
import React from 'react';
import { SizeType } from 'common-ts/dist/models/Cart';
import { useAppDispatch } from '../reduxhooks';
import CloseIcon from '@material-ui/icons/Close';
import { StarWarsNameCard } from './OverlayViewUniversalSize0BenefitStart';
import { UserBodyMeasurements } from 'common-ts/dist/models/UserMeasurements';
import AccessibilityNewIcon from '@material-ui/icons/AccessibilityNew';
import EditIcon from '@material-ui/icons/Edit';
import RestoreIcon from '@material-ui/icons/Restore';

const CATEGORY_FADE_DURATION_MS = 600;
const CATEGORY_FADE_DELAY_MS = 200;
const CATEGORY_SLIDE_DURATION_MS = 500;
const CATEGORY_SLIDE_DELAY_MS = CATEGORY_FADE_DURATION_MS + CATEGORY_FADE_DELAY_MS;
const CATEGORY_FOOTER_TRANSITION_DELAY_MS = CATEGORY_SLIDE_DURATION_MS + CATEGORY_SLIDE_DELAY_MS;

const useStyles = makeStyles((theme: Theme) =>
createStyles({
  dialogContentContainer: {
    height: '100%',
  },
  stickyHeader: {
    position: 'sticky',
    top: 0,
    height: '3.15rem',
    zIndex: theme.zIndex.appBar,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    backgroundColor: theme.palette.background.paper,
    padding: '0',
  },
  stickyCategoryTabs: {
    position: 'sticky',
    height: '3rem',
    top: '5.15rem',
    zIndex: theme.zIndex.appBar - 1,
    backgroundColor: theme.palette.background.paper,
  },
  headerRowOne: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    borderBottom: `0.5px solid ${theme.palette.divider}`,
  },
  headerRowLeft: {
    whiteSpace: 'nowrap',
    paddingLeft: '5%',
    textAlign: 'left',
  },
  headerText: {
    fontWeight: 400,
    fontSize: '0.6em',
    color: 'black',
    fontFamily: 'Open sans, sans-serif',
  },
  headerRowRight: {
    whiteSpace: 'nowrap',
    textAlign: 'right',
    marginLeft: 'auto',
  },
  userName: {
    fontWeight: 600,
    color: '#121212',
    fontSize: '0.8em',
    paddingTop: '0.5em',
  },
  closeButton: {
    height: '100%',
    paddingRight: '1em',
  },
  headerRowTwo: {
    whitespace: 'nowrap',
    boxShadow: '0px 2.5px 10px rgba(0, 0, 0, 0.1)',
  },
  personalSizeTabs: {
    minHeight: 'auto',
  },
  personalSizeTab: {
    fontSize: '0.5em',
    minHeight: 'auto',
    padding: '0.8em',
  },
  personalSizeActiveTab: {
    fontWeight: 'bold',
  },
  personalSizePanel: {

  },
  existUniversalSizeDisplay: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    // padding: '0em 1em',
  },
  existUniversalSizeCardContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
  },
  existUniversalSizeIntro: {
    fontWeight: 400,
    fontSize: '0.6em',
    color: 'black',
    fontFamily: 'Open sans, sans-serif',
    margin: '3em 0em 1em 0em',
  },
  existUniversalSizeIntro2: {
    fontWeight: 400,
    fontSize: '0.6em',
    color: 'black',
    fontFamily: 'Open sans, sans-serif',
    margin: '0em 0em 2em 0em',
  },
  existUniversalSizeCardImage: {
    marginTop: '-0.5em',
    width: '50%',
  },
  existUniversalSizeButtons: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    marginBottom: '1em',
  },
  buatUkuranBaruButton: {
    display: 'flex',
    alignItems: 'center',
    gap: '0.5em',
    marginTop: '-0.2em',
    marginBottom: '0.2em',
  },
  existUniversalSizeTitle: {
    margin: '1em 0em',
    fontSize: '1em',
    fontWeight: 600,
  },
  universalSizeImages: {
    position: 'absolute',
    left: '0',
    right: '0',
    marginLeft: 'auto',
    marginRight: 'auto',
    top: '4em',
    width: '100%',
    height: '50%',
    overflow: 'hidden',
  },
  universalSizeLeftImg: {
    position: 'absolute',
    width: '85%',
    left: '-6.5em',
  },
  universalSizeCardImg: {
    width: '100%'
  },
  universalSizeRightImg: {
    position: 'absolute',
    width: '75%',
    top: '1em',
    right: '-4.5em',
  },
  universalSizeTextContent: {
    position: 'absolute',
    left: '0',
    right: '0',
    top: '26.5em',
    marginLeft: 'auto',
    marginRight: 'auto',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    flexDirection: 'column',
  },
  universalSizeSubtitle: {
    fontSize: '0.6em',
    fontWeight: 400,
    color: '#A7A7A7',
  },
  universalSizeTitle: {
    fontSize: '1.5em',
    width: '70%',
    fontWeight: 600,
    marginTop: '0.3em',
    marginBottom: '0.7em',
    lineHeight: '1.2em',
  },
  universalSizeDescription: {
    fontSize: '0.7em',
    fontWeight: 400,
    width: '90%',
    marginBottom: '1em',
  },
  universalSizeButton: {
    width: '100%',
  },
  categoryContent: {
    padding: '0 1em',
    marginBottom: '5rem',
  },
  misalignedProductsDisplay: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    columnGap: '0.6em',
    paddingBottom: "180px",
  },
  misalignedLeftProduct: {

  },
  misalignedRightProduct: {
    marginTop: '1.4em',
    marginBottom: '0.4em',
  },
  categoryFooter: {
    position: 'fixed',
    bottom: '0',
    width: '100%',
    zIndex: theme.zIndex.appBar,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    textAlign: 'center',
    backgroundColor: theme.palette.background.paper,
    padding: '0',
    boxShadow: '0px -5px 10px rgba(0, 0, 0, 0.1)',
    visibility: 'hidden',
  },
  categoryFooterAnim: {
    position: 'fixed',
    bottom: '0',
    width: '100%',
    zIndex: theme.zIndex.appBar,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    textAlign: 'center',
    backgroundColor: theme.palette.background.paper,
    padding: '0',
    boxShadow: '0px -5px 10px rgba(0, 0, 0, 0.1)',
    opacity: '0',
    transition: `opacity ${CATEGORY_FADE_DURATION_MS}ms ease ${CATEGORY_FADE_DELAY_MS}ms, transform ${CATEGORY_SLIDE_DURATION_MS}ms ease ${CATEGORY_SLIDE_DELAY_MS}ms`,
  },
  footerText: {
    fontWeight: 600,
    color: '#121212',
    fontSize: '0.6em',
    marginTop: '1em',
    marginBottom: '1em',
  },
  popupTitle: {
    padding: '0.5em 0.5em 0 0.5em',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  popupTitlePilihUkuranText: {
    fontSize: '12px',
    color: '#D1D1D1',
    fontWeight: 300,
    padding: '16px 0px 0px 18px'
  },
  popupCloseButton: {
    marginRight: '3px',
  },
  popupContent: {
    padding: '0 1em',
    marginBottom: '1em',
  },
  ukuranBadanOptionsBox: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  },
  ukuranBadanOptionsIcon: {
    backgroundColor: '#232323',
    color: '#ffffff',
    borderRadius: '40px'
  },
  ukuranBadanOptionsText: {
    color: '#565656',
    fontSize: '9px',
    letterSpacing: '0.13px',
    marginTop: '10px'
  },
  ukuranBadanInfoIslandOption: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '30%',
    height: '60%',
    textAlign: 'center',
  },
  ukuranBadanInfoIslandOptionText: {
    color: '#565656',
    fontSize: '2vw',
    letterSpacing: '0.1vw',
  },
  ukuranBadanInfoIslandOptionSubtextHeightWeight: {
    color: '#565656',
    fontSize: '3.5vw',
    letterSpacing: '0.1vw',
    fontWeight: 500,
    paddingTop: '0.2vw',
  },
  ukuranBadanInfoIslandOptionSubtextBodyType: {
    color: '#565656',
    fontSize: '3vw',
    paddingTop: '0.6vw',
    letterSpacing: '0.1vw',
    fontWeight: 500,
  },
  ukuranBadanInfoIslandOptionSubtextBodyType2Line: {
    color: '#565656',
    fontSize: '2.3vw',
    letterSpacing: '0.07vw',
    fontWeight: 500,
    marginTop: '-0.1vw',
  },
}),
);

interface Props {
  currentBodyMeasurementObj: UserBodyMeasurements
  handleLihatHasil: () => void
  handleEditUkuran: () => void
  handleBuatUlang: () => void
  handleClose: () => void
}

export default function Page({ currentBodyMeasurementObj, handleLihatHasil, handleEditUkuran, handleBuatUlang, handleClose }: Props) {
  const classes = useStyles();
  const dispatch = useAppDispatch();

  return (
    <Box style={{
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
    }}>
      <Box key={'ukuran-badan-header'} style={{
        height: '56px',
        width: '100%',
        position: 'relative',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'flex-end'
      }}>
        <Typography style={{
          fontSize: '11px',
          letterSpacing: '0.8px',
          paddingTop: '3px'
        }}>
          UKURAN BADAN KAMU
        </Typography>
        <Box style={{
          position: 'absolute',
          top: '16px',
          right: '16px',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center'
        }}
          onClick={handleClose}
        >
          <ButtonBase
            style={{
              backgroundColor: '#ffffff',
              color: '#232323',
              padding: '4px',
              borderRadius: '40px'
            }}>
            <CloseIcon/>
          </ButtonBase>
        </Box>
      </Box>
      <Box key={'ukuran-badan-present-slider'}
        style={{
          position: 'relative',
          width: '100%',
          marginTop: '-10px',
          overflowX: 'clip',
          zIndex: 1,
        }}>
          <StarWarsNameCard name={currentBodyMeasurementObj.nama ?? ''} isOneName={true}/>
      </Box>
      <Box key={'ukuran-badan-footer'} style={{
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      }}>
        <Box key={'ukuran-badan-options'} style={{
          padding: '20px 0px 40px 0px',
          width: '70vw',
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'space-between',
          zIndex: 1
        }}>
          <Box className={classes.ukuranBadanOptionsBox} 
            onClick={handleLihatHasil}
            >
            <ButtonBase className={classes.ukuranBadanOptionsIcon} 
            style={{
              backgroundColor: '#232323'
            }}>
              <AccessibilityNewIcon style={{ padding: '9px' }}/>
            </ButtonBase>
            <Typography className={classes.ukuranBadanOptionsText}
            style={{
              color: '#232323'
            }}>
              Hasil Baju
            </Typography>
          </Box>
          <Box className={classes.ukuranBadanOptionsBox} 
            onClick={handleEditUkuran}
            >
            <ButtonBase className={classes.ukuranBadanOptionsIcon}
            style={{
              backgroundColor: '#232323'
              // backgroundColor: '#b9b9b9'
            }}>
              <EditIcon style={{ padding: '9px' }}/>
            </ButtonBase>
            <Typography className={classes.ukuranBadanOptionsText}
            style={{
              color: '#232323'
              // color: '#b9b9b9'
            }}>
              Edit Ukuran
            </Typography>
          </Box>
          <Box className={classes.ukuranBadanOptionsBox} 
            onClick={handleBuatUlang}>
            <ButtonBase className={classes.ukuranBadanOptionsIcon}
            style={{
              backgroundColor: '#232323'
            }}>
              <RestoreIcon style={{ padding: '9px' }}/>
            </ButtonBase>
            <Typography className={classes.ukuranBadanOptionsText}
            style={{
              color: '#232323'
            }}>
              Buat Ulang
            </Typography>
          </Box>
        </Box>
        <img 
          src={"https://studiosclo.uk/general/ukuran-badan-detail-bg.jpg"} 
          alt="measkit-img"
          style={{
            width: "100%",
            objectFit: "cover",
            position: 'absolute',
            bottom: '0px',
            left: '0px',
            zIndex: 0
          }}/>
      </Box>
    </Box>
  );
}